// eltがfeature読み込んでないのでcoreに配置する必要がある
import { z } from 'zod'

// dbのsource.config のスキーマは現在はelt内にあるがフロントエンド側で必要になったものを順次引越させる

export const salesforceCredentialsSpec = z.object({
  credentials: z.object({
    // 空文字を弾くのは「DB が常に正」を spec で保証するため (issue #9395)。jsforce v3 の _establish は
    // `this.refreshToken = refreshToken || this.refreshToken` という falsy ガードを持ち、空文字を渡すと
    // 黙って conn の既存値を温存する。空文字が DB に入ると「DB を読んで conn へ反映した」つもりの経路が
    // 実際には旧世代を握り続け、RTR の family invalidation を遅れて踏む。
    refreshToken: z.string().min(1),
    instanceUrl: z.string(), // instanceUrlはcredentialsではないので、ここに含めるべきではないが、初期設計時のミスでここに入れている
    clientId: z.string().optional(),
    clientSecret: z.string().optional(),
    version: z.enum(['58.0', '66.0']).optional(), // ここで厳密にチェックして間違ったバージョン記法が混入するのを避ける。しかし、59.0とかで指定したときにエラーになる将来的なリスクがややでかいかも…
    // access_token を Source.config に永続化することで、resolver / job ごとの conn 生成時に refresh を走らせず再利用できる (issue #9395)。
    // 期限切れ判定は Salesforce 側に委譲 (= 期限切れなら 401 → refresh)。既存行は optional のまま (初回 refresh で埋まる)。
    accessToken: z.string().optional(),
  }),
  meta: z
    .object({
      email: z.string(),
      username: z.string(),
      display_name: z.string(),
      organization_id: z.string(),
      user_id: z.string().optional(), // 後から追加したのでoptional
    })
    .optional(), // 後から追加したので、初期の組織には存在しない。
  // 直接的にはInActiveなUserを取得するためのフラグを作成するため。今後の活用があるかも？
  option: z
    .object({
      fetchInactiveUser: z.boolean().default(false).optional(),
      fetchArchivedRecord: z.boolean().default(false).optional(),
    })
    .optional(),
})

export type SalesforceSpec = z.infer<typeof salesforceCredentialsSpec>

// eslint-disable-next-line sonarjs/todo-tag
// TODO: いずれ全部引っ越しさせて整備する
const sourceConfigUnionSchema = z.discriminatedUnion('provider', [
  z.object({
    provider: z.literal('salesforce'),
    config: salesforceCredentialsSpec,
  }),
])

export const hubspotSpecSchema = z.object({
  credentials: z.object({
    refreshToken: z.string(),
  }),
  scope: z.string(),
  portalId: z.number(),
  option: z
    .object({
      fetchArchivedOwner: z.boolean().default(false).optional(),
    })
    .optional(),
})
export type HubspotSpec = z.infer<typeof hubspotSpecSchema>
